<template>
  <div>
    <v-card>
      <div>
        <v-row>
          <v-col
            cols="12"
            md="6"
            sm="5"
            lg="5"
            :order="$vuetify.breakpoint.xs ? 'last' : ''"
          >
            <div
              :class="$vuetify.breakpoint.xs ?
                'd-flex flex-column px-3' :
                'd-flex align-center px-3'
              "
              v-if="$permission('116')"
              >
              <v-autocomplete
                v-model="selectedCategory"
                v-if="$permission('116')"
                :items="listCategories"
                :label="$t('selectCategory')"
                item-text="name"
                item-value="id"
                :loading="isLoading"
                clearable
                hide-details
                solo-inverted
                chips
                small-chips
                @click:clear="clearable()"
                :no-data-text="$t('noDataOptions')"
                dense
                :disabled="disableSelectCategories"
              >
                <template v-slot:selection="{ item }">
                  <v-chip small>
                    <v-icon
                    :color="handleColorStatus(item.status)"
                    x-small
                    left
                    >
                      mdi-circle
                    </v-icon>
                    {{ item.name }} <span v-show="item.status == 0" class="ml-2">({{ statusUI(item.status)}})</span>
                  </v-chip>
                </template>

                <template v-slot:item="{ item }">
                  <!-- {{ item.name }} -->
                  <v-icon
                  :color="handleColorStatus(item.status)"
                  x-small
                  left
                >
                  mdi-circle
                </v-icon>
                  {{ item.name }} <span v-show="item.status == 0" class="ml-2">({{ statusUI(item.status)}})</span>
                </template>
              </v-autocomplete>
              <div class="d-flex justify-end" v-if="$permission('116')">
                <v-btn
                  class="info ml-3"
                  :class="$vuetify.breakpoint.xs ? 'mt-3' : ''"
                  :small="$vuetify.breakpoint.xs"
                  @click="bindGamesToCategory()"
                  :loading="isLoading"
                  :disabled="
                    isLoading ||
                    disableSelectCategories ||
                    (selectedCategory &&
                      selectedCategory.length == 0
                    ) ||
                    selectedCategory == undefined"
                >
                  {{ $t('btnSave') }}
                </v-btn>
              </div>
            </div>
          </v-col>
          <v-col
            cols="12"
            md="2"
            sm="3"
            lg="3"
            offset-sm="4"
            offset-lg="4"
            :order="$vuetify.breakpoint.xs ? 'first' : ''"
          >
            <v-text-field
              v-model="search"
              class="px-3"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              dense
              solo-inverted
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <v-divider></v-divider>
      <v-data-table
        v-model="selectedGames"
        :headers="headers"
        :items="listGames"
        :search="search"
        style="width: 100%"
        :show-select="$permission('116')"
        item-key="id_game"
        @toggle-select-all="selectAll"
        @current-items="currentItems"
        :page.sync="page"
        :no-data-text="$t('noDataFount')"
        :footer-props="{
          'items-per-page-text': this.$t('rowsPerPage'),
          'items-per-page-options': [5, 10, 15],
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
        }"
      >
        <!-- <template v-slot:item.data-table-select="{ item, isSelected, select }">
          <v-simple-checkbox
            :value="isSelected"
            @input="(select($event), currentGameSelected = item)"
            :ripple="false"
          ></v-simple-checkbox>
        </template> -->

        <template v-slot:header.name_game="{ header }">
          {{ header.text }}
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                small
                v-bind="attrs"
                v-on="on"
              >
                mdi-information-outline
              </v-icon>
            </template>
            <div class="d-flex flex-column">
              <span>{{ $t('systemGameStatus') }}</span>
              <span>
                <v-icon
                color="green"
                left
                >●</v-icon>
                {{ $t('active') }}
              </span>
              <span>
                <v-icon
                color="grey"
                left
                >●</v-icon>
                {{ $t('inactive') }}
              </span>
            </div>
          </v-tooltip>
        </template>

        <template v-slot:header.visible="{ header }">
          {{ header.text }}
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                small
                v-bind="attrs"
                v-on="on"
              >
                mdi-information-outline
              </v-icon>
            </template>
            <span v-html="$t('visibleGameTxt')"></span>
          </v-tooltip>
        </template>

        <template v-slot:header.payout="{ header }">
          {{ header.text }}
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                small
                v-bind="attrs"
                v-on="on"
              >
                mdi-information-outline
              </v-icon>
            </template>
            <span v-html="$t('casinoRTP')"></span>
          </v-tooltip>
        </template>

        <template v-slot:header.volatility_rating="{ header }">
          {{ header.text }}
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                small
                v-bind="attrs"
                v-on="on"
              >
                mdi-information-outline
              </v-icon>
            </template>
            <span v-html="$t('casinoVolatility')"></span>
          </v-tooltip>
        </template>

        <template slot="no-results">
          <span>
            {{ $t('noDataFount') }}
          </span>
        </template>

        <template v-slot:item.id_game="{ item }">
          <v-btn class="text-lowercase" @click="$copy(item.id_game)" x-small>
            {{ item.id_game }}
          </v-btn>
        </template>

        <template v-slot:item.img="{ item }">
          <div class="my-3">
            <div
              v-if="showIcon.includes(item.id_game)"
              class="d-flex justify-center"
            >
              <v-icon large>mdi-image</v-icon>
            </div>
            <div
              v-else
              class="d-flex justify-center"
            >
              <v-img
                max-width="100"
                :src="src(item.identifier)"
                @error="imgError(item.id_game)"
              >
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
          </div>
        </template>

        <template v-slot:item.name_game="{ item }">
          <div class="d-flex align-center">
            <v-icon
              :color="handleColorStatus(item.status)"
              left
            >●</v-icon>
            {{ item.name_game }}
          </div>
        </template>

        <template v-slot:item.name_provider="{ item }">
          <div class="my-3">
            <div
              v-if="showDefaultImgProvider.includes(item.id_game)"
              class="d-flex justify-center"
            >
              <v-icon large>mdi-image</v-icon>
            </div>
            <div
              v-else
              class="d-flex justify-center pa-1"
              style="
                background-color: rgb(223, 223, 223);
                border-radius: 4px;
              "
            >
              <v-img
                width="64"
                :src="srcProviderImg(item.identifier)"
                @error="imgErrorProvider(item.id_game)"
                >
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
          </div>
          <!-- {{ item.name_provider }} -->
        </template>

        <template v-slot:item.payout="{ item }">
          {{ item.payout }}%
        </template>


        <template v-slot:item.volatility_rating="{ item }">
          {{ $t( `${item.volatility_rating}` ) || $t('low') }}
        </template>

        <template v-slot:item.categories="{ item }">
          <div v-if="!$vuetify.breakpoint.xs" class="d-flex flex-column">
            <!-- itera as categorias no datatable desktop -->
            <div
              v-for="(category, index) in item.categories.slice(0, 2)"
              :key="index"
            >
              <v-chip
                class="ma-1"
                small
                outlined
                @click="$copy(category.category_name)"
              >
                <v-icon
                  :color="handleColorStatus(category.category_status)"
                  left
                >●</v-icon>
                {{ category.category_name }}
              </v-chip>
            </div>
            <div v-if="item.categories.length > 2" class="d-flex justify-start my-2">
              <v-btn
                text
                color="primary"
                x-small
                @click.prevent="($set(showCategoriesDialog, item.id_game, true), showMore = item.id_game)"
                >
                <!-- @click="toggleShowMore(item.id_game)" -->
                {{ showMore == item.id_game ? $t('showLess') : `${$t('showMore')} (${item.categories.length - 2})` }}
              </v-btn>
            </div>
            <!-- <div v-else-if="item.categories.length == 0">
              {{ $t('noCategory') }}
            </div> -->
          </div>

          <!-- visualizar categorias data-table -->
            <span
              v-if="item.categories.length == 0"
              :class="item.description ? '' : 'grey--text'"
            >
              {{$t('noCategory')}}
            </span>
            <v-dialog
              v-else
              v-model="showCategoriesDialog[item.id_game]"
              :key="item.id_game"
              max-width="500"
              :retain-focus="false"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-show="$vuetify.breakpoint.xs"
                  v-bind="attrs"
                  text
                  color="primary"
                  small
                  v-on="on"
                  @click.prevent="($set(showCategoriesDialog, item.id_game, true), showMore = item.id_game)"
                >
                  {{ $t('view') }} ({{ item.categories.length }})
                </v-btn>
              </template>
              <v-toolbar dense>
                <v-toolbar-title>
                  {{ $t('categories') }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                  icon
                  @click.prevent="($set(showCategoriesDialog, item.id_game, false), showMore = '')"
                >
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
              </v-toolbar>
              <v-card class="py-6 px-10">
                <v-row class="d-flex">
                  <div
                    v-for="(category, index) in visibleCategories(item.id_game, item.categories)"
                    class="d-flex"
                    :key="index"
                  >
                    <v-chip
                      class="ma-1"
                      outlined
                      @click="$copy(category.category_name)"
                    >
                      <v-icon
                        :color="handleColorStatus(category.category_status)"
                        left
                      >●</v-icon>
                      {{ category.category_name }}
                    </v-chip>
                  </div>
                </v-row>
              </v-card>
            </v-dialog>
        </template>

        <template v-slot:item.visible="{ item }">
          <div
            :class="handleColorVisibleGame(item.hasOneCategoryActive)">
            {{ item.hasOneCategoryActive }}
          </div>
        </template>

        <template v-slot:item.live="{ item }">
          <div>
            {{ typeUI(item.live) }}
          </div>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn-toggle>
            <UpdateGame :game="item" @refreshList="refreshList" />
          </v-btn-toggle>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import UpdateGame from "./updateGame.vue";
export default {
  name: "list-games",
  components: {
    UpdateGame,
  },
  data: () => ({
    page: 1,
    search: "",
    hasFilteredItems: false,
    listGames: [],
    selectedCategory: [],
    selectedGames: [],
    showIcon: [],
    showDefaultImgProvider: [],
    listCategories: [],
    isLoading: false,
    categoryName: "",
    disableSelectCategories: true,
    showCategoriesDialog: {},
    showMore: "",
    filteredItems: [],
  }),

  computed: {
    headers() {
      return [
        {
          text: "ID",
          value: "id_game",
          align: "no-wrap",
        },
        {
          text: this.$t("image"),
          value: "img",
          align: "no-wrap",
        },
        {
          text: this.$t("game"),
          value: "name_game",
          align: "no-wrap",
          // width: "15%",
        },
        {
          text: this.$t("provider"),
          value: "name_provider",
          align: "no-wrap",
          width: "100",
        },
        {
          text: "RTP",
          value: "payout",
          align: "no-wrap",
          // width: "15%",
        },
        {
          text: this.$t('volatilityRating'),
          value: "volatility_rating",
          align: "no-wrap",
          // width: "15%",
        },
        {
          text: this.$t("customCategories"),
          value: "categories",
          align: "no-wrap",
          width: "15%",
        },
        {
          text: this.$t('providerCategories'),
          value: "categorie_provider",
          align: "no-wrap",
        },
        {
          text: this.$t('casinoTheme'),
          value: "theme",
          align: "no-wrap",
        },
        {
          text: "Lobby",
          value: "live",
          align: "no-wrap",
        },
        {
          text: this.$t('gameDisplayed'),
          value: "visible",
          align: "no-wrap",
        },
        // {
        //   text: "Status",
        //   value: "status",
        // align: "no-wrap",
        // },
        {
          text: this.$t("actions"),
          value: "actions",
          align: "no-wrap",
        },
      ];
    },
    providerId() {
      return this.$store.state.filters.autocompleteProvidersByOperator.id;
    },

    stringProviderId() {
      return this.$store.state.filters.autocompleteProvidersByOperator.stringId;
    },

    categorieName() {
      return this.$store.state.filters.autocompleteCasinoCategories.name;
    },

    categoriesList() {
      return this.$store.state.casinoCategoriesList;
    },

    casinoLobbyType() {
      return this.$store.state.filters.selectCasinoLobby.value;
    },

    casinoTheme() {
      return this.$store.state.filters.selectCasinoTheme.value;
    },

    casinoVerticalCategory() {
      return this.$store.state.filters.selectCasinoVerticalCategory.value;
    },

    saveFilters() {
      return this.$store.state.filters.save;
    },

    progress() {
      return this.$store.state.feedbackProgress;
    },
  },

  watch: {
    selectedGames(val) {
      val.length > 0 ?
        this.disableSelectCategories = false :
          this.disableSelectCategories = true;
    },

    casinoLobbyType() {
      this.listGames = []
      this.selectedGames = []
      this.selectedCategory = []
    },

    categoriesList(val) {
      this.listCategories = val
    },

    saveFilters(val) {
      if (
        !this.providerId &&
        !this.categorieName
      ) {
        this.$store.commit("setSave", false);
        this.$store.commit("DisabledSave", false);
        this.$store.commit("setFeedbackProgress", false);
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t('chooseAtLeastOneCategoryOrProvider'),
          color: "warning",
        });
        return
      }

      val && this.fetchListGames();
      val && this.$store.commit("setFeedbackProgress", true);
    },
  },

  methods: {
    fetchListGames() {
      const body = {
        id_provider: this.providerId ? this.providerId : "",
        category: this.categorieName,
        live: this.casinoLobbyType,
        category_provider: this.casinoVerticalCategory,
        theme: this.casinoTheme
      };
      this.$axios
        .post("/colab/cassino/GamesAgregation/listGames", this.$formdata(body))
        .then((response) => {
          const formatGamesData = response.data.dados.map((game) => ({
            ...game,
            hasOneCategoryActive: game.categories
              .find((category) => category.category_status == "1") ?
                this.$t('yes') :
                this.$t('no'),
          }));
          this.listGames = []
          this.listGames = formatGamesData;
        })
        .catch(() => {
          this.listGames = []
        });
    },

    selectAll(selectData) {
      if (selectData.value && !this.hasFilteredItems) {
        this.selectedGames = this.listGames;
      }
      else if (this.hasFilteredItems && selectData && selectData.value) {
        this.selectedGames = this.filteredItems
      }
      else {
        this.selectedGames = [];
      }
    },
    /*
      currentItems: event do data-table que observa a lista dos itens atuais na página, e também
      só os filtrados
    */
    currentItems(value) {
      if (
        this.listGames &&
        this.listGames.length > 0 &&
        this.search != null &&
        this.search.length > 0
      ) {
        this.hasFilteredItems = true;
        this.filteredItems = value
      } else {
        this.hasFilteredItems = false;
        this.filteredItems = []
      }
    },

    src(game_identifier) {
      return encodeURI(
        `https://cdn.softswiss.net/i/s1/${game_identifier.split(":")[0]}/${game_identifier.split(":")[1]}.png`
      );
    },

    srcProviderImg(provider_identifier) {
      return `https://cdn.softswiss.net/logos/providers/color/${provider_identifier.split(":")[0]}.svg`
      ;
    },

    imgError(gameId) {
      this.showIcon.push(gameId);
    },

    imgErrorProvider(gameId) {
      this.showDefaultImgProvider.push(gameId);
    },

    bindGamesToCategory() {
      if (this.selectedGames.length == 0) return
      this.isLoading = true

      const body = {
        category_id: this.selectedCategory,
      }
      this.selectedGames.forEach((game, i) => {
        body[`id_games[${i}]`] = game.id_game;
      })

      this.$axios.post("colab/cassino/GamesAgregation/bindGamesToCategory", this.$formdata(body))
      .then((response) => {
        this.$store.commit("setFeedbackSnack", {
          msg: response.data.dados,
          color: "success",
        });

        this.refreshList()
        this.selectedGames = []
        this.selectedCategory = []
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => this.isLoading = false)
    },

    handleColorStatus(status) {
      if (status == 0) return "grey";
      if (status == 1) return "green";
    },

    typeUI(value) {
      const obj = {
        0: this.$t('casino'),
        1: this.$t('liveCasino'),
      };
      return obj[value];
    },

    handleColorVisibleGame(status) {
      if (status == this.$t('no')) return "warning--text";
      if (status == this.$t('yes')) return "green--text";
    },

    statusUI(value) {
      const obj = {
        0: `${this.$t( "inativa" )}`,
        1: `${this.$t( "ativa" )}`,
      };
      return obj[value];
    },
    
    payoutColor(value) {
      if (value == 0) return "grey--text";
      if (value > 0) return "green--text";
      if (value < 0) return "red--text";
    },

    refreshList() {
      this.fetchListGames();
    },

    clearable() {
      this.selectedCategory = [];
    },

    visibleCategories(idGame, categories) {
      if(categories.length == 0) return
      const visibleCount = this.showMore == idGame ? categories.length : 2;
      return categories.slice(0, visibleCount);
    },

    toggleShowMore(idGame) {
      this.showMore = this.showMore == idGame ? "" : idGame
    },
  },
};
</script>

<style scoped>
.v-tooltip__content {
  font-size: 14px !important;
  max-width: 256px !important;
  opacity: 1 !important;
  padding: 16px 16px;
}
</style>
